import { RouteConfig } from 'vue-router';
import { LazyLoadRoute } from '@shared/router/util';
import { store } from '@shared/store';

export const UploadRoutes: RouteConfig[] = [
    {
        name: 'Upload',
        path: '/upload',
        component: () => LazyLoadRoute(import('./Upload.vue')),
        beforeEnter(to, from, next) {
            if (store.getters['isAuthenticated'])
                return next();

            return next('/authentication/signin');
        }
    },
];
